import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SzModulesMenuComponent } from '../sz-modules-menu';
import { SzProfileMenuComponent } from '../sz-profile-menu';

@Component({
  selector: 'sz-top-bar',
  templateUrl: './sz-top-bar.component.html',
  styleUrls: ['./sz-top-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzModulesMenuComponent, SzProfileMenuComponent]
})
export class SzTopBarComponent {}
